import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State } from './state';

export const selectProjectState = createFeatureSelector<State>('studio-detail');
